import { Link } from '@/lib/router-compat';
import { Button } from '@/components/ui/button';
import { Settings, ArrowRight, Brain, ChartBar, Truck } from 'lucide-react';

const ServicesOverview = () => {
  const serviceHighlights = [
    {
      icon: Brain,
      title: 'AI Engineering',
      description: 'Enterprise grade AI solutions from strategy to deployment, including Multi Agent Systems for complex workflows and unprecedented automation.'
    },
    {
      icon: Settings,
      title: 'Enterprise IT Solutions',
      description: 'Comprehensive IT infrastructure, system integration, and security services for secure, scalable enterprise environments.'
    },
    {
      icon: ChartBar,
      title: 'Program Management & Strategy',
      description: 'Expert program management and strategic consulting leveraging proven methodologies to ensure successful delivery and transformation.'
    },
    {
      icon: Truck,
      title: 'Supply Chain Optimization',
      description: 'End to end supply chain management and optimization leveraging AI and analytics for maximum efficiency.'
    }
  ];

  return (
    <section id="services" className="section-padding bg-muted/30 relative overflow-hidden border-t border-border/50">
      <div className="container-max relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight text-primary">
            Our Services
          </h2>
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-semibold mb-4 text-foreground">
              Integrity<span className="text-primary">.</span> Excellence<span className="text-primary">.</span> Innovation<span className="text-primary">.</span>
            </h3>
            <p className="text-lg text-muted-foreground">
              AI-native engineering firm specializing in enterprise services, domain-specific solutions, and high-performance infrastructure from strategy through deployment.
            </p>
          </div>
        </div>

        <div className="mb-16 grid grid-cols-1 divide-y divide-border border-y border-border lg:grid-cols-4 lg:divide-x lg:divide-y-0">
          {serviceHighlights.map((service) => (
            <div key={service.title} className="flex flex-col px-6 py-8 transition-colors duration-150 ease-out hover:bg-muted/40">
              <service.icon className="mb-6 h-5 w-5 text-primary" strokeWidth={1.75} aria-hidden />
              <h3 className="mb-3 text-lg font-semibold leading-tight text-foreground lg:min-h-[2.5em]">{service.title}</h3>
              <p className="flex-grow text-sm leading-relaxed text-muted-foreground">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button asChild className="btn-hero group">
            <Link to="/services" className="flex items-center">
              View All Services
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
